import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { ConfirmationDialog } from "@/components/molecules/ConfirmationDialog";
import SWR_KEYS from "@/constants/swr-keys";
import useGetAllCustomerSalesProducts from "@/hooks/requests/customer-sales-product/use-get-all-customer-sales-product";
import useUpdateCustomerSalesProduct from "@/hooks/requests/customer-sales-product/use-update-customer-sales-product";
import useDialog from "@/hooks/use-dialog";
import useMutate from "@/hooks/use-mutate";
import ICustomerSalesProduct from "@/interfaces/customer-sales-product.interfaces";
import { CustomerMessages } from "@/messages/customer/customer.messages";
import { CustomerSalesProductStatus } from "@/types/customer-sales-product.types";

import ActivePlanView from "./components/ActivePlanView";
import { defaultPageNumber as pageNumber, defaultPageSize as pageSize } from "./constants";

type Props = {
  messages: CustomerMessages;
};

const PlansManagementTab = ({ messages }: Props) => {
  const { mutate } = useMutate();
  const { data } = useGetAllCustomerSalesProducts({ pageNumber, pageSize });
  const { update } = useUpdateCustomerSalesProduct();
  const { isVisible, handleOpen, handleClose, selected } = useDialog<ICustomerSalesProduct>();

  const { planUpdateSuccess, planUpdateError } = messages;

  const onConfirmCancel = async (selectedPlan: ICustomerSalesProduct) => {
    const successMessage = planUpdateSuccess;
    const errorMessage = planUpdateError;
    const _id = selectedPlan.id;
    const salesProductId = selectedPlan.salesProduct.id;
    const salesProductPriceId = selectedPlan.salesProductPrice.id;
    const status = CustomerSalesProductStatus.Inactive;
    const formData = { ...selectedPlan, salesProductId, salesProductPriceId, status };
    const onSuccess = () => mutate(SWR_KEYS.getAllCustomerSalesProducts);

    await update({ _id, formData, successMessage, errorMessage, onSuccess });

    handleClose();
  };

  return (
    <MDBox mt={2}>
      <Grid container spacing={3}>
        <Grid size={12}>
          {!!data?.items && (
            <ActivePlanView data={data.items} messages={messages} onCancelPlan={handleOpen} />
          )}
        </Grid>
      </Grid>

      {selected && (
        <ConfirmationDialog
          isOpen={isVisible}
          onClose={handleClose}
          onConfirm={() => onConfirmCancel(selected)}
          titleText={messages.confirmCancelDialogTitle}
          descriptionText={messages.confirmCancelDialogDescription}
          cancelText={messages.cancelButton}
          confirmText={messages.confirmButton}
        />
      )}
    </MDBox>
  );
};

export default PlansManagementTab;
